/**
 * Комбо: серия верных ответов подряд в текущем занятии. Каждый ответ —
 * событие с номером, чтобы квокка-тренер реагировала даже на два
 * одинаковых ответа подряд.
 */

import { useEffect } from 'react';
import { create } from 'zustand';

export interface AnswerEvent {
  readonly id: number;
  readonly correct: boolean;
  readonly streak: number;
}

interface ComboStore {
  readonly streak: number;
  readonly best: number;
  readonly last: AnswerEvent | null;
  /** Экран со своей квоккой (карточки фраз) прячет квокку-тренера в углу. */
  readonly coachHidden: boolean;
  setCoachHidden: (hidden: boolean) => void;
  report: (correct: boolean) => void;
  reset: () => void;
}

export const useComboStore = create<ComboStore>()((set, get) => ({
  streak: 0,
  best: 0,
  last: null,
  coachHidden: false,
  setCoachHidden: (coachHidden) => set({ coachHidden }),
  report: (correct) => {
    const { streak, best, last } = get();
    const next = correct ? streak + 1 : 0;
    set({ streak: next, best: Math.max(best, next), last: { id: (last?.id ?? 0) + 1, correct, streak: next } });
  },
  reset: () => set({ streak: 0, last: null }),
}));

/** Сообщает итог ответа один раз — когда `result` перестаёт быть `null`. */
export function useReportAnswer(result: boolean | null): void {
  const report = useComboStore((state) => state.report);
  useEffect(() => {
    if (result !== null) report(result);
  }, [report, result]);
}

/** Пока компонент на экране, квокка-тренер в углу спрятана: у экрана своя квокка. */
export function useHideCoach(): void {
  const setCoachHidden = useComboStore((state) => state.setCoachHidden);
  useEffect(() => {
    setCoachHidden(true);
    return () => setCoachHidden(false);
  }, [setCoachHidden]);
}
